import { profilePath, remixInAbletonUrl, seedPath } from "@/lib/ctas";

/**
 * Share a seed's page: the system share sheet where there is one (phones),
 * else the link onto the clipboard. Resolves to what happened, so the caller
 * can say "Link copied".
 */
export async function shareSeed(seed: { id: string; title: string }): Promise<"shared" | "copied" | "failed"> {
  const url = new URL(seedPath(seed.id), window.location.origin).toString();
  try {
    if (navigator.share) {
      await navigator.share({ title: seed.title, text: `${seed.title} on Seedbed`, url });
      return "shared";
    }
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
}

/** Share a producer's profile, the same way `shareSeed` shares a seed. */
export async function shareProfile(profile: { handle: string; name: string }): Promise<"shared" | "copied" | "failed"> {
  const url = new URL(profilePath(profile.handle), window.location.origin).toString();
  try {
    if (navigator.share) {
      await navigator.share({ title: profile.name, text: `${profile.name} on Seedbed`, url });
      return "shared";
    }
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
}

/**
 * Send yourself the link that gets a seed into Live — for a phone, where the
 * extension can't be installed: the share sheet (mail, messages, AirDrop) or
 * the clipboard.
 */
export async function shareAbletonLink(seed: { id: string; title: string }): Promise<"shared" | "copied" | "failed"> {
  const url = remixInAbletonUrl(seed.id);
  try {
    if (navigator.share) {
      await navigator.share({ title: seed.title, text: `Open ${seed.title} in Ableton Live`, url });
      return "shared";
    }
    await navigator.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
}
